import React from 'react';
import {MasterLayout} from 'components/layouts';
import {RequestDetail} from 'components/requests';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import {BusinessLayout} from 'components/layouts/business';
import title from 'constants/TitlePages.js';

class RequestDetailPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      business: this.props.business || {}
    }
  }

  componentDidMount() {
    document.title = title.RequestDetail;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.business != this.state.business) {
      this.setState({
        business: nextProps.business
      })
    }
  }

  render() {
    return (
      <MasterLayout>
        <BusinessLayout active='mybusiness-requests'>
          <RequestDetail id={this.props.match.params.id} type="MY_BUSINESS_REQUEST"/>
        </BusinessLayout>
      </MasterLayout>
    );
  }
}

export default BusinessZone(RequestDetailPage);



// WEBPACK FOOTER //
// ./pages/my-business/RequestDetail.jsx